import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IContact, JobApplicationsModel} from '../../../../core/models';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {JobsService} from '../../../../core/services';
import {ChatService} from '../../../../core/services/chat.service';
import {ChatDialogComponent} from '../chat-dialog/chat-dialog.component';
import {IChatRoom} from '../../../../dashboard/inbox/helpers/chat-box.component';
import {SuccessDialogFastComponent} from '..';

@Component({
  selector: 'app-candidate-dialog',
  templateUrl: './candidate-dialog.component.html',
  styleUrls: ['./candidate-dialog.component.css']
})
export class CandidateDialogComponent implements OnInit {
  jobApplicationData: JobApplicationsModel = {} as JobApplicationsModel;
  jobTitle = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { app: JobApplicationsModel, jobTitle: string },
    private mdDialogRef: MatDialogRef<CandidateDialogComponent>,
    private dialog: MatDialog,
    private jobService: JobsService,
    private chatService: ChatService,
  ) {}

  ngOnInit() {
    this.jobApplicationData = this.data.app;
    this.jobTitle = this.data.jobTitle;
    const el = document.getElementById('candidate');
    el.scrollIntoView();
  }

  close() {
    this.mdDialogRef.close();
  }

  update(field, value) {
    const dataToUpdate = {};
    dataToUpdate[field] = value;
    console.log(dataToUpdate);
    this.jobService.updateApplication(this.jobApplicationData._id, dataToUpdate).subscribe( result => {
      console.log(result);
    });
  }

  goToChat() {
    this.chatService.addContact(this.jobApplicationData.user_id._id, this.jobApplicationData._id).subscribe( res => {
      console.log(res);
      this.openChatDialog(res.contact);
    });
  }

  openChatDialog(contact: IContact) {
    const dialogRef = this.dialog.open(ChatDialogComponent, {
      panelClass: 'full-screen-modal',
      data: {
        currentPartner: contact,
        messagesList: [] as IChatRoom[]
      }
    });
  }

  openSuccessDialog() {
    const dialogRef = this.dialog.open(SuccessDialogFastComponent, {
      data: {
        title: 'השינויים נשמרו בהצלחה!',
        message: '',
        cancelText: '',
        confirmText: 'אישור'
      }
    });
  }
}
